<div class="p-6 pb-3 {{ textClass }} {{ backgroundClass }}">
  <div class="container basic-content-service row mx-auto">
    <div class="col-12 col-sm-7 col-md-7 text-end d-flex justify-content-end align-items-end" id="initiative-title">
      <h2 class="grid-container">
        <span *ngIf="title" [innerHTML]="title | safe: 'html'"></span>     
      </h2>
    </div>
    <div class="position-relative service-img-container col-12 col-sm-5 col-md-5 pt-3 d-flex justify-content-center" id="service-img-container-13">
      <img src="{{ imgBannerUrl | blobstorage }}" alt="{{altImgBanner}}" class="img-fluid mb-3 img-width-hero">
    </div>
  </div>
</div>
